'use es6';

import get from 'transmute/get';
export const getLanguage = get('language');
export const getSearchableKnowledgeBaseIds = get('searchableKnowledgeBaseIds');
export const getGates = get('gates');